import _get from "./get";

const EmployeeManager = {
  _get,
};

export default EmployeeManager;
